import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/apiBaseUrl';
import { ButtonGroup, ButtonToolbar, Button, Form, Pagination, Dropdown, DropdownButton} from 'react-bootstrap';
import './Admin.css';
import teamIcons from './../../utils/teamIcons';
import teamColors from './../../utils/teamColors';
import CurrentWeekNum from './../../utils/CurrentWeekNum';
import { AccountContext } from './../../components/UserPool/Account';
import AlertModal from '../../components/AlertModal/AlertModal';
import AdminEnterPickModal from '../../components/AdminEnterPickModal/AdminEnterPickModal'

// API article https://medium.com/swlh/skip-lambda-save-data-to-dynamodb-directly-using-api-gateway-process-later-with-streams-dab2ceef9a9d
function Admin({year}) {
    const { getSession } = useContext(AccountContext);
    const [newSession, setNewSession] = useState(undefined);

    const [adminActiveButtonArr, setAdminActiveButtonArr] = useState(Array(18).fill(Array(32).fill(null)));
    // API - current week of season
    const [activePage, setActivePage] = useState(CurrentWeekNum(year));
    const [showSubmitButton, setShowSubmitButton] = useState(false);

    const [matchupsArr, setMatchupsArr] = useState([[]]);
    const [resultsArr, setResultsArr] = useState([[]]);
    
    const [showAdminAlertModal, setShowAdminAlertModal] = useState([false, '', ''])
    const [allUserData, setAllUserData] = useState([]);

    const [showAdminEnterPickModal, setShowAdminEnterPickModal] = useState(false)
    const [adminEnterPickUser, setAdminEnterPickUser] = useState('User')
    const [adminEnterPickWeek, setAdminEnterPickWeek] = useState(CurrentWeekNum(year))
    const [adminEnterPickTeam, setAdminEnterPickTeam] = useState('')
    // Server truth for "has this week's deadline passed" -- see EnterPicks.js/
    // CurrentWeek.js for why this can't be derived from the client's own
    // hardcoded date tables for 2026+ seasons.
    const [serverCurrentWeek, setServerCurrentWeek] = useState(null);
    const [serverEligibility, setServerEligibility] = useState(null);

    useEffect(() => {
        getSession(setNewSession)
          .then((session) => {
            console.log('Session Activated');
          })
          .catch((err) => {
            console.log('Session: ', err);
          });
        
      }, []);

    function getAllMatchups() {
        const week = 1
        axios.get(`${API_BASE_URL}/get-all-matchups`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json'
            },
            params: {year, week}
        }).then((response) => {
            setMatchupsArr(response['data']['matchups']);
            setServerCurrentWeek(response['data']['currentWeek']);
            setServerEligibility(response['data']['eligibility']);
        }).catch((error) => {
            console.log(error);
            setShowAdminAlertModal([true, 'Unable to get matchups. Try refreshing page and trying again.', 'We\'ve hit a snag'])
        })
    }

    // Is `weekNum`'s Sunday-noon-CT deadline in the past? Any week strictly
    // before the server's current week has necessarily already passed; the
    // current week uses the server's precomputed eligibility flag directly.
    function isWeekPast(weekNum) {
        if (serverCurrentWeek == null) return null;
        if (weekNum < serverCurrentWeek) return true;
        if (weekNum > serverCurrentWeek) return false;
        return serverEligibility === false;
    }

    function getCurrentResults() {
        axios.get(`${API_BASE_URL}/admin-get-results`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json'
            },
            params: {year}
        }).then((response) => {
            setResultsArr(response['data'])
            setShowSubmitButton(true);
        }).catch((error) => {
            console.log(error); 
            setShowAdminAlertModal([true, 'Unable to get results. Try refreshing page and trying again.', 'We\'ve hit a snag'])
        })
    }

    function submitResults(event, results) {
        event.preventDefault();
        axios.put(`${API_BASE_URL}/admin-submit-results`,
            {
                'weekNum': activePage,
                'pastDeadline': isWeekPast(activePage) === true,
                'results': results
            },
            {
                headers: {
                    Authorization: newSession['idToken']['jwtToken'],
                    'Content-Type': 'application/json'
                },
                params: {year}
            }
        ).then((response) => {
            window.location.reload();
        }).catch((error) => {
            console.log(error); 
            setShowAdminAlertModal([true, 'Unable to submit results.', 'We\'ve hit a snag'])
        });
    }

    function getAllPicks(weekNum) {
        axios.get(`${API_BASE_URL}/all-users`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json',
            },
            params: {'week_num': weekNum, 'is_admin': true, year}
        }).then((response) => {
            const users = response['data']
            const userNames = []
            for (let i = 0; i < users.length; i++) {
                userNames.push(Object.keys(users[i])[0])
            }
            userNames.sort((a, b) => a.localeCompare(b))
            setAllUserData(userNames);
        }).catch((error) => {
            console.log(error); 
        });
    }

    async function enterUserPick() {
        await axios.put(`${API_BASE_URL}/submit-pick`, 
            {
                'username': adminEnterPickUser,
                'weekNum': adminEnterPickWeek,
                'pick': adminEnterPickTeam,
                'is_admin': false
            },
            {
                headers: {
                    Authorization: newSession['idToken']['jwtToken'],
                    'Content-Type': 'application/json'
                },
                params: {year}
            }
        ).then((response) => {
            console.log('Submitted pick manually')
        }).catch((error) => {
            setShowAdminAlertModal([true, 'Unable to sumit user pick.', 'We\'ve hit a snag'])
            console.log(error);
        });
    }

    useEffect(() => {
        if(newSession !== undefined) {
            getAllMatchups();
            getCurrentResults();
        }
      }, [newSession]);

    useEffect(() => {
        console.log('SHOW')
        if(newSession !== undefined && showAdminEnterPickModal) {
            getAllPicks(activePage);
        }
      }, [showAdminEnterPickModal]);      

    let items = []
    for(let i = 1; i < 19; ++i) {
        items.push(
            <Pagination.Item key={i} active={i === activePage} onClick={(event)=>{
                setActivePage(i);
            }}>
                {i}
            </Pagination.Item>
        );
    }

    function handleTeamChosen(event, i, isFirst) {
        let buttonText = event.target.innerText;
        if(buttonText === undefined) {
            const iconText = (event.target.nearestViewportElement) ? event.target.nearestViewportElement.id : event.target.id;
            if(iconText === undefined) {
                return;
            }
            buttonText = iconText;
        }

        const currName = buttonText;
        let trimmedName = currName.trim();
        const unclickTeam = (typeof(resultsArr[activePage-1][trimmedName]) !== 'string' && resultsArr[activePage-1][trimmedName]) ? true : false;

        let newActiveArr = {...adminActiveButtonArr}
        let newActiveSubArr = newActiveArr[activePage-1];

        if(!newActiveArr[activePage-1][i]) {
            newActiveSubArr[i] = true;
            if(isFirst) newActiveSubArr[i+1] = false;
            else newActiveSubArr[i-1] = false;
        }
        else {
            newActiveSubArr[i] = null;
            if(isFirst) newActiveSubArr[i+1] = null;
            else newActiveSubArr[i-1] = null;
        }
        // newActiveSubArr[i] = unclickTeam ? false : true;

        newActiveArr[activePage-1] = newActiveSubArr;
        setAdminActiveButtonArr(newActiveArr);

        let newResultsArr = {...resultsArr};
        let otherTeam;

        if(isFirst) {
            otherTeam = matchupsArr[activePage-1][Math.floor(i/2)].split(' ')[2];
        }
        else {
            otherTeam = matchupsArr[activePage-1][Math.floor(i/2)].split(' ')[0];
        }

        if(unclickTeam) {
            newResultsArr[activePage-1][trimmedName] = '';
            newResultsArr[activePage-1][otherTeam] = '';
        } else {
            newResultsArr[activePage-1][trimmedName] = true;
            newResultsArr[activePage-1][otherTeam] = false;
        }
        setResultsArr(newResultsArr);
    }

    let arrButtons = [];

    let firstTeam = '';
    let secondTeam = '';
    let firstIncumbent;
    let secondIncumbent;
    if(matchupsArr.length > 1 && Object.keys(resultsArr).length > 1) {
        for (let i = 0; i < matchupsArr[activePage-1].length * 2; i+=2) { 
            firstTeam = matchupsArr[activePage-1][i/2].split(' ')[0];
            secondTeam = matchupsArr[activePage-1][i/2].split(' ')[2];
            var NFLTeamOne = teamIcons[firstTeam];
            var NFLTeamTwo = teamIcons[secondTeam];
            
            if(!resultsArr || resultsArr.length < 2) {
                firstIncumbent = false;
                secondIncumbent = false;
            } else {       
                firstIncumbent = (typeof(resultsArr[activePage-1][firstTeam]) == 'string' || !resultsArr[activePage-1][firstTeam]) ? false : true;
                secondIncumbent = (typeof(resultsArr[activePage-1][secondTeam]) == 'string' || !resultsArr[activePage-1][secondTeam]) ? false : true;             
            }

            // Admin marks a winner rather than making a pick, but reuses the
            // same outline-primary button -- give it the same team-brand
            // accent as EnterPicks.js instead of the generic orange.
            const firstTeamStyle = {'--pick-team-color': teamColors[firstTeam]};
            const secondTeamStyle = {'--pick-team-color': teamColors[secondTeam]};

            let firstTeamButton;
            if(firstIncumbent) {
                firstTeamButton = <Button key={i} variant='outline-primary' className='pick-select-button' style={firstTeamStyle} active onClick={(event)=>handleTeamChosen(event,i, true)}> <NFLTeamOne/> {firstTeam} </Button>
            } else {
                firstTeamButton = <Button key={i} variant='outline-primary' className='pick-select-button' style={firstTeamStyle} active={(resultsArr[activePage-1][firstTeam] === '') ? false : resultsArr[activePage-1][firstTeam]} onClick={(event)=>handleTeamChosen(event,i, true)}> <NFLTeamOne/> {firstTeam} </Button>
            }

            let secondTeamButton;
            if(secondIncumbent) {
                secondTeamButton = <Button key={i+1} variant='outline-primary' className='pick-select-button' style={secondTeamStyle} active onClick={(event)=>handleTeamChosen(event,i+1, false)}> <NFLTeamTwo/> {secondTeam} </Button>
            } else {
                secondTeamButton = <Button key={i+1} variant='outline-primary' className='pick-select-button' style={secondTeamStyle} active={(resultsArr[activePage-1][secondTeam] === '') ? false : resultsArr[activePage-1][secondTeam]} onClick={(event)=>handleTeamChosen(event,i+1, false)}> <NFLTeamTwo/> {secondTeam} </Button>
            }

            // Same one-matchup-per-row approach as EnterPicks.js -- see
            // EnterPicks.css .matchup-row for why.
            arrButtons.push(
                <div className='matchup-row' key={i+'-row-admin'}>
                    {firstTeamButton}
                    {secondTeamButton}
                </div>
            )
        }
    }
    
    function handleAdminSubmit(event) {
        event.preventDefault();
        let weekResults = {};
        let firstTeam, secondTeam;

        for (let i = 0; i < matchupsArr[activePage-1].length * 2; i+=2) { 
            firstTeam = matchupsArr[activePage-1][i/2].split(' ')[0];
            secondTeam = matchupsArr[activePage-1][i/2].split(' ')[2];
            weekResults[firstTeam] = resultsArr[activePage-1][firstTeam];
            weekResults[secondTeam] = resultsArr[activePage-1][secondTeam];
        }

        submitResults(event, weekResults);
    }

    if(!newSession || (newSession['idToken']['payload']['cognito:groups'] && newSession['idToken']['payload']['cognito:groups'][0] !== 'admin')) {
        return (
            <>
                <div className='admin-reject-section'>
                    <p> This page is for admins only...</p>
                </div>
        </>
        )
    }

     

    return (
        <>
            <div className='main-section-admin'>
                <div className='page-header'>
                    <h1 className='page-title'>Admin</h1>
                    <p className='page-subtitle'>Enter results and submit picks on behalf of users</p>
                </div>
                <div className='team-section-admin'>
                    <Form onSubmit={handleAdminSubmit}>
                        <ButtonToolbar aria-label='Toolbar with button groups'>
                            <ButtonGroup className='me-2 team-group-admin' aria-label='First group'>
                                {/* <div className='individual-matchup-section'> */}
                                    {arrButtons}
                                {/* </div> */}
                                <p className='breaker'/>
                                {
                                    showSubmitButton
                                        ? <Button className='admin-submit' type='submit'> Submit </Button>
                                        : ''
                                }                                
                            </ButtonGroup>
                        </ButtonToolbar>
                    </Form>
                    <p className='breaker'/>
                    <Button className='admin-submit' style={{width: '100%'}} variant='info' onClick={() => {setShowAdminEnterPickModal(true)}}> Enter User Pick </Button>
                    {
                        showSubmitButton
                         ? <Pagination className='pagination-admin'>{items}</Pagination>
                         : ''
                    }
                </div>
                <AlertModal
                    show={showAdminAlertModal[0]}
                    onHide={()=>{setShowAdminAlertModal([false, '', ''])}}
                    modalTitle={showAdminAlertModal[2]}
                    modalBody={showAdminAlertModal[1]}
                />   
            </div>
            <AdminEnterPickModal
                userList={allUserData}
                showModal={showAdminEnterPickModal}
                setShowModal={setShowAdminEnterPickModal}
                enterUserPick={enterUserPick}
                adminEnterPickUser={adminEnterPickUser}
                setAdminEnterPickUser={setAdminEnterPickUser}
                adminEnterPickWeek={adminEnterPickWeek}
                setAdminEnterPickWeek={setAdminEnterPickWeek}
                adminEnterPickTeam={adminEnterPickTeam}
                setAdminEnterPickTeam={setAdminEnterPickTeam}
            />
        </>
    )
}

export default Admin;